import { z } from "zod";

/** Mirrors backend `StagingDiversion` in system_settings_models.py. */
export const stagingDiversionShape = {
  base_location: z.string().catch(""),
  catalog: z.string().nullable().catch(null),
  database_suffix: z.string().nullable().catch(null),
  table_suffix: z.string().nullable().catch(null),
};

export interface StagingDiversion {
  base_location: string;
  catalog: string | null;
  database_suffix: string | null;
  table_suffix: string | null;
}

export interface SystemSettingsStagingDiversionProps {
  value: StagingDiversion;
  onChange: (patch: Partial<StagingDiversion>) => void;
  /** URI scheme a full base location must use, e.g. "gs://" or "s3://". */
  scheme: string;
}
